import React                          from 'react'
import moment                         from 'moment'
import classnames                     from "classnames"
import { Popover, Icon, Badge, Spin, Tag, notification, Modal } from 'antd'

import {bindActionCreators} from "redux"
import {withRouter}         from "react-router-dom"
import {connect}            from "react-redux"

import { on_migration_progress,
    on_migration_complete,
    refresh_migrations_history, on_migration_failed, aws_migrations_history } from '../../../actions/migrations'

import List                            from './NotifyList'
import {refresh_profile}   from "../../../actions/auth"
import { fetch_clouds, fetch_buckets } from '../../../actions/cloud-accounts-actions'

import CloudFlyerAPI     from "../../../api/CloudFlyerAPI"
import s3Icon         from '../../../assets/logo/s3-three.png'

import bellIcon         from '../../../assets/svg/notification.svg'
import { ReactComponent as Logo } from '../../../assets/svg/notification.svg';

import './styles.scss'

class NotifyIcon extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            loading : false,
            count :0,
            visible : false,
            notifications : []
        }
    }

    componentDidMount(){
        //this.refresh()

        this.connect_rm()

        const {has_billing_info=false, trial_status='', trial_expiration=''} = (JSON.parse(localStorage.getItem('user')))||{}
        const days_left = 1000 //Math.round((new Date(trial_expiration).getTime() - new Date().getTime()) / 86400000)

        this.setState({has_billing_info, trial_status, days_left})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.REFRESH_RM) this.connect_rm()
    }

    on_popup_visible_change = visible => this.setState({visible}, () => visible ? this.refresh() : null)

    on_clear =()=> {
        let notifications = this.state.notifications
        for (let key in notifications) {
            notifications[key].read = true
        }

        this.setState({notifications, count:0}, ()=>{
            CloudFlyerAPI.notifications
                .read(notifications.map(n=> n.id))
                .catch(console.error)
        })
    }

    on_click = notification => {
        const { history } = this.props
        let notifications = this.state.notifications
        for (let key in notifications.filter(n=> n.id === notification.id)) {
            notifications[key].read = true
        }
        this.setState({visible:false, notifications, count:notifications.filter(n=> !n.read).length}, ()=>{
            history.push('/setAlert/' + notification.id)
            CloudFlyerAPI.notifications
                .read([notification.id])
                .then(this.refresh)
                .catch(console.error)
        })
    }

    connect_rm =()=> {
        let $this = this
        CloudFlyerAPI.rm
            .on(rm => {
                /*
                console.log('############### WEBSOCKET ###############')
                console.log('kind', rm.type)
                console.log('#########################################')
                MigrationEnqueued,
                MigrationStarted,
                MigrationUnauthorized,
                MigrationProcessing,
                MigrationCanceled,
                MigrationSucceeded,
                MigrationFailed,
                MigrationVerifyFailed,
                MigrationDeleted,
                MigrationCanceled
                */

                switch (rm.type) {
                    case 'NotificationCreated':
                        notification.warning({
                            message: 'Notification Alerts',
                            description: 'You have new notification'
                        })
                        $this.refresh()
                        break

                    case 'MigrationEnqueued':
                    case 'MigrationStarted':
                        this.props.refresh_migrations_history()
                        break

                    case 'MigrationProcessing':
                        this.props.on_migration_progress(rm.payload)
                        break

                    case 'MigrationFailed':
                    case 'MigrationCanceled':
                        this.props.on_migration_failed(rm.payload)
                        this.props.refresh_migrations_history()
                        break

                    case 'MigrationSucceeded':
                        this.props.on_migration_complete(rm.payload)
                        //this.props.refresh_migrations_history()
                        this.props.aws_migrations_history(1)
                        notification.success({
                            key:'MigrationSucceeded',
                            message: 'Success!',
                            description: 'Transfer completed successfully'
                        })
                       /*
                        Modal.destroyAll()
                        Modal.info({
                            icon: <span/>,
                            content: 'We are working through a technical issue with moving data/files between clouds.  Please feel free to copy your content and verify that it has arrived safely in the destination bucket.  We will have this issue resolved shortly.'
                        })
                        */
                        break

                    case 'UserUpdated':
                        this.props
                            .fetch_clouds(clouds =>{
                                for (let key in clouds)
                                    $this.props.fetch_buckets(clouds[key].id)
                            })
                        break
                }
            })
    }

    refresh =()=>{
        let $this = this
        CloudFlyerAPI.notifications
            .notifies()
            .then(res=>{
                if(!res || !((res||{}).data||{}))
                    return
                let notifications = ((res||{}).data||{}).filter(n=> n.last_notified).map((notice) => {
                    const newNotice = { ...notice }
                    newNotice.avatar = s3Icon //(<Icon type="warning" style={{ fontSize: 24, color: '#08c' }} />)
                    if (newNotice.last_notified) {
                        newNotice.last_notified = moment(notice.last_notified).fromNow()
                    }
                    if (newNotice.id) {
                        newNotice.key = newNotice.id;
                    }
                    if (newNotice.status) {
                        const color = ({
                            normal: '',
                            processing: 'blue',
                            error: 'red',
                            warning: 'gold',
                            alerts: 'gold'
                        })[newNotice.status]
                        newNotice.extra = (<Tag color={color} style={{ marginRight: 0 }}>{newNotice.status}</Tag>)
                    }
                    return newNotice
                })
                $this.setState({notifications, count:notifications.filter(n=> !n.read).length})
            })
            .catch(console.error)
    }

    render() {
        const {
            notifications,
            loading,
            count,
            has_billing_info,
            trial_status,
            days_left
        } = this.state

        const popoverProps = {}
        if ('popupVisible' in this.props) {
            popoverProps.visible = this.props.popupVisible
        }

        return (
            <Popover
                placement       = 'bottomRight'
                visible         = {this.state.visible}
                popupClassName  = {'popover-notify'}
                trigger         = 'click'
                popupAlign      = {{offset:[20, -16]}}
                onVisibleChange = {this.on_popup_visible_change}
                className       = {'notify'}
                arrowPointAtCenter

                content={
                    <Spin spinning={loading} delay={0}>
                        <List
                            notifications={notifications}
                            onClick={this.on_click}
                            onClear={this.on_clear}
                            title={'title'}
                        />
                        {/* {
                            !has_billing_info &&
                            <div className={classnames({'trial-label':true, 'trial-status': trial_status })}>
                                <Badge count={days_left} style={{ backgroundColor: (days_left < 5 ? (days_left < 2 ? 'red':'yellow'): '#52c41a') }} />
                                <span>&nbsp;days left of your trial</span>
                            </div>
                        } */}
                    </Spin>
                }>

        <span className={'noticeButton'}>
           <Badge count={count} dot={!count && !has_billing_info && days_left < 10}>
                <Logo className="header-notification-icon"/>
                {/* <img src={bellIcon} className="header-notification-icon" /> */}
           </Badge>
        </span>

            </Popover>
        )
    }
}

export default withRouter(connect(({auth:{user, REFRESH_RM}}) => {
    return {
        ...user,
        REFRESH_RM
    }
}, dispatch => bindActionCreators({fetch_clouds, on_migration_progress, refresh_migrations_history, aws_migrations_history, on_migration_complete, on_migration_failed, fetch_buckets, refresh_profile}, dispatch))(NotifyIcon))
